"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTeamsFiles = void 0;
var _TeamsAndChannelsContext = require("@/context/TeamsAndChannelsContext");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useTeamsFiles = exports.useTeamsFiles = function useTeamsFiles() {
  var _useTeamsAndChannels = (0, _TeamsAndChannelsContext.useTeamsAndChannels)(),
    teamsFiles = _useTeamsAndChannels.teamsFiles,
    setTeamsFiles = _useTeamsAndChannels.setTeamsFiles,
    selectedRows = _useTeamsAndChannels.selectedRows,
    setSelectedRows = _useTeamsAndChannels.setSelectedRows;
  var addTeamsFiles = function addTeamsFiles(newFiles) {
    setTeamsFiles(function (prevFiles) {
      // Merge files avoiding duplicates based on ID
      var existingIds = new Set(prevFiles.map(function (file) {
        return file.id;
      }));
      var uniqueNewFiles = newFiles.filter(function (file) {
        return !existingIds.has(file.id);
      });
      return [].concat(_toConsumableArray(prevFiles), _toConsumableArray(uniqueNewFiles));
    });
  };
  var updateTeamsFile = function updateTeamsFile(fileId, updatedFile) {
    setTeamsFiles(function (prevFiles) {
      return prevFiles.map(function (file) {
        return file.id === fileId ? _objectSpread(_objectSpread({}, file), updatedFile) : file;
      });
    });
  };
  var removeTeamsFile = function removeTeamsFile(fileId) {
    setTeamsFiles(function (prevFiles) {
      return prevFiles.filter(function (file) {
        return file.id !== fileId;
      });
    });
  };
  var clearTeamsFiles = function clearTeamsFiles() {
    setTeamsFiles([]);
  };
  var getTeamsFileById = function getTeamsFileById(fileId) {
    return teamsFiles.find(function (file) {
      return file.id === fileId;
    });
  };
  var getTeamsFilesByParentId = function getTeamsFilesByParentId(parentId) {
    return teamsFiles.filter(function (file) {
      return file.parentReference.id === parentId;
    });
  };
  var getTeamsFilesByChannel = function getTeamsFilesByChannel(driveId, itemId) {
    return teamsFiles.filter(function (file) {
      return file.channel.drive_id === driveId && file.channel.item_id === itemId;
    });
  };
  var addSelectedRow = function addSelectedRow(file) {
    setSelectedRows(function (prev) {
      var exists = prev.includes(file.id);
      return exists ? prev : [].concat(_toConsumableArray(prev), [file.id]);
    });
  };
  var removeSelectedRow = function removeSelectedRow(fileId) {
    setSelectedRows(function (prev) {
      return prev.filter(function (id) {
        return id !== fileId;
      });
    });
  };
  var clearSelectedRows = function clearSelectedRows() {
    setSelectedRows([]);
  };
  var isRowSelected = function isRowSelected(fileId) {
    return selectedRows.includes(fileId);
  };
  var getSelectedFiles = function getSelectedFiles() {
    return teamsFiles.filter(function (file) {
      return selectedRows.includes(file.id);
    });
  };
  var getSelectedFilesByParentId = function getSelectedFilesByParentId(parentId) {
    return teamsFiles.filter(function (file) {
      return selectedRows.includes(file.id) && file.parentReference.id === parentId;
    });
  };
  var getAllSelectedFiles = function getAllSelectedFiles() {
    return teamsFiles.filter(function (file) {
      return file.selected === true;
    });
  };
  return {
    teamsFiles: teamsFiles,
    setTeamsFiles: setTeamsFiles,
    addTeamsFiles: addTeamsFiles,
    updateTeamsFile: updateTeamsFile,
    removeTeamsFile: removeTeamsFile,
    clearTeamsFiles: clearTeamsFiles,
    getTeamsFileById: getTeamsFileById,
    getTeamsFilesByParentId: getTeamsFilesByParentId,
    getTeamsFilesByChannel: getTeamsFilesByChannel,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    addSelectedRow: addSelectedRow,
    removeSelectedRow: removeSelectedRow,
    clearSelectedRows: clearSelectedRows,
    isRowSelected: isRowSelected,
    getSelectedFiles: getSelectedFiles,
    getSelectedFilesByParentId: getSelectedFilesByParentId,
    getAllSelectedFiles: getAllSelectedFiles
  };
};